<template>

  <div id="app" class="cf cf-form" data-app>

    <!-- uklad przeniesiony z CardFinance2: tresc + przyklejony panel decyzji
         z kalkulatorem i CTA. Pola renderuje DynamicField wg form_config,
         pogrupowane w sekcje po tytulach blokow (stepSections) -->
    <div class="cf-promise">

      <!-- ================= TRESC ================= -->
      <div class="cf-promise__main">


        <!-- bledy z backendu / walidacji -->
        <div v-if="formErrors" class="cf-form-alert" role="alert">
          <strong>Niektóre pola formularza są niepoprawnie wprowadzone.</strong>
          <ul>
            <li v-for="field in invalidFields">{{ field }}</li>
          </ul>
        </div>


        <!-- naglowek kroku -->
        <div v-if="!String( specialStep ).match(/^kontox/)" class="cf-stack" style="gap:10px">
          <span class="cf-eyebrow">Wniosek o pożyczkę<template v-if="steps > 1 && !String( specialStep ).match(/^verifycode/)"> · część {{ activeStep }} z {{ steps }}</template></span>
          <h1 class="cf-h1">{{ stepTitle }}</h1>

          <p v-if="activeStep == 1 && !loggedIn" class="cf-lead" style="margin:0">Masz już konto?
            <a href="#" data-bs-toggle="modal" data-bs-target="#loginDialog" @click.prevent>Zaloguj się</a> — dane uzupełnimy
            za Ciebie. Nowym klientom założenie konta zajmuje kilka minut.</p>
          <p v-else-if="activeStep == 1" class="cf-lead" style="margin:0">Dane z Twojego konta uzupełniliśmy za Ciebie —
            sprawdź je, ustaw parametry pożyczki i przejdź dalej.</p>
          <p v-else-if="String( specialStep ).match(/^verifycode/)" class="cf-lead" style="margin:0">Na podany numer telefonu
            wysłaliśmy SMS z kodem. Wpisz go poniżej, aby potwierdzić numer i przejść dalej.</p>
        </div>


        <!-- kalkulator w tresci - tylko mobile (na desktopie panel boczny) -->
        <div v-if="!String( specialStep ).match(/^kontox/)" class="cf-form__calc-mobile">
          <NauCalcPanel endpoint="" />
        </div>


        <!-- ================= SEKCJE POL ================= -->
        <section v-for="sec in stepSections" :key="sec.key" v-show="!isBlockHidden(sec)"
                 class="cf-stack cf-stack--4" :class="{ 'cf-card cf-card--action cf-consents-card': sec.consents }">

          <!-- zgody: karta z licznikiem i "zaznacz wszystkie wymagane" -->
          <div v-if="sec.consents" class="cf-consents__head">
            <div class="cf-stack" style="gap:5px">
              <h2 class="cf-section-title">{{ sec.element ? sec.element.title : 'Oświadczenia i zgody' }}</h2>
              <p class="cf-meta" style="margin:0">Zaznaczono <strong>{{ consentsChecked }}</strong> z {{ requiredConsentNames.length }} wymaganych</p>
            </div>
            <div class="cf-row" style="gap:16px">
              <div class="cf-progress" role="progressbar" aria-valuemin="0"
                   :aria-valuemax="requiredConsentNames.length" :aria-valuenow="consentsChecked" aria-label="Postęp zgód">
                <div class="cf-progress__bar" :style="{ width: consentsPct + '%' }"></div>
              </div>
              <button v-if="requiredConsentNames.length > 1" type="button" class="cf-link-action" @click="checkAllRequired">Zaznacz wszystkie wymagane</button>
            </div>
          </div>

          <BlockTitle v-else-if="sec.element" :element="sec.element" :name="sec.key" />


          <div class="cf-form-grid">

            <div v-for="(row, ri) in sec.rows" :key="sec.key + '-' + ri" class="cf-row-contents">

              <DynamicField
                v-for="(entry, index) in row"

                :count="row.length"

                :key="entry[0]"
                :name="entry[0]"
                :index="index"

                :element="entry[1]"

                :filled="isFilled"

                :vuelidator="$v.form[ entry[0] ]"

                :form="form"
              />

            </div>

          </div>

        </section>


        <!-- ================= VERIFY CODE ================= -->
        <section v-if="String( specialStep ).match(/^verifycode/)" class="cf-stack cf-stack--4">
          <h2 class="cf-section-title">Wprowadź kod SMS</h2>

          <div class="cf-form-grid">
            <div class="cf-field">
              <label class="cf-field__label" for="f-verifycode">Kod SMS</label>
              <input id="f-verifycode" ref="verifycode" type="text" class="cf-input" inputmode="numeric" autocomplete="one-time-code"
                     placeholder="Kod SMS" v-mask="'NNNNNN'"
                     v-model="form['verifycode']"
                     @keyup.enter="next"
                     @input="$emit('input', $event.target.value); $v.form['verifycode'] && $v.form['verifycode'].$touch()"
                     :class="{ 'is-invalid': $v.form['verifycode'] && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty }"
                     :data-error="$v.form['verifycode'] && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty ? 'true' : null"
                     :data-valid="$v.form['verifycode'] && !$v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty ? 'true' : null"
              >
              <span class="cf-field__error" v-if="$v.form['verifycode'] && verifycode_hint && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty">{{ verifycode_hint }}</span>

              <!-- CTA tuz pod polem kodu (Enter tez wysyla); panel boczny trzyma drugi egzemplarz -->
              <div class="cf-stack" style="gap:8px;align-items:flex-start;margin-top:6px">
                <a class="cf-btn cf-btn--primary" style="min-width:220px" @click="next">Wyślij kod</a>
                <span class="cf-meta">Kod z SMS-a jest ważny kilka minut.</span>
              </div>
            </div>
          </div>
        </section>


        <!-- ================= KONTOMATIK ================= -->
        <section class="cf-stack cf-stack--4" v-show="String( specialStep ).match(/^kontox/)">
          <h2 class="cf-section-title">Weryfikacja konta bankowego</h2>
          <p class="cf-lead" style="margin:0">Wybierz swoje główne konto, abyśmy mogli je zweryfikować — na to konto wyślemy
            Twoją pożyczkę. Pamiętaj, aby było to konto, na które wpływa np. Twoje wynagrodzenie. Weryfikacja tego konta
            ma wpływ na Twoją zdolność kredytową.</p>
          <div id="kontox" class="cf-kontox"></div>
        </section>


        <!-- ================= DEBUG ================= -->
        <div v-if="debug == 'on'" class="cf-row">
          <a key="btn-filldbg" v-if="activeStep <= steps" class="cf-btn cf-btn--quiet" @click="filldebug">DEBUG</a>
          <a class="cf-btn cf-btn--quiet" @click="doNextStep">next</a>
          <a key="btn-axios" class="cf-btn cf-btn--quiet" @click="testroute">test</a>
        </div>

      </div>


      <!-- ================= PANEL DECYZJI: kalkulator + CTA ================= -->
      <aside class="cf-promise__aside">

        <NauCalcPanel endpoint="" />

        <div class="cf-divider"></div>

        <div class="cf-stack" style="gap:10px">
          <a key="btn-next" v-if="activeStep <= steps && !String( specialStep ).match(/^kontox/)"
             class="cf-btn cf-btn--primary cf-btn--block" @click="next">{{ String( specialStep ).match(/^verifycode/) ? 'Wyślij kod' : activeStep == steps ? 'Składam wniosek' : 'Dalej' }}</a>
          <p class="cf-meta" style="margin:0;text-align:center">{{ ctaHint }}</p>
        </div>

      </aside>

    </div>

  </div>
</template>

<script>

import __form_config from './conf/form_config.json';

//import { validationMixin } from 'vuelidate';

import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';


import { validatePolish } from 'validate-polish';


import DynamicField from '@/components/DynamicField';
import BlockTitle from '@/components/BlockTitle';
import SignContract from '@/components/SignContract';
import NauCalcPanel from '@/components/NauCalcPanel';




export default {
  name: 'DynamicForm',
  components: { DynamicField, BlockTitle, SignContract, NauCalcPanel },


  props: {
      form: {
          type: Object,
          required: true
      }
  },


  data() {
    return {

      debug: this.getConf('debug'),
      tests: this.getConf('tests'),

      page: null,
      fmap: null,

      fillDone: false,
      delayedTask: null,


      activeStep: 1,
      steps: 1,

      // widocznosc sekcji (tytulow blokow __cmp_BlockTitle*) sterowana
      // zdarzeniem 'visibility' (CheckToggler, np. adres korespondencyjny)
      hiddenBlocks: {},
      schema: [{}],

      verifycode_hint: '',

      formErrors: false,

      invalidFields: [],

      isFilled: false,

      // status calls
      waiting: '',
      waitCount: 0,


      editMode: 'persist',


      dynamicValidation: {}
    }
  },

  computed: {

    loggedIn(){

      return this.$root.mainpage.loggedIn;
    },


    // tytul biezacego kroku w naglowku formularza
    stepTitle(){

      if (String(this.specialStep).match(/^verifycode/)) {
        return 'Potwierdź numer telefonu';
      }

      return this.activeStep == 1 ? 'Złóż wniosek o pożyczkę' : 'Uzupełnij dane do wniosku';
    },


    // --- redesign (CardFinance2): pola kroku pogrupowane w sekcje po tytulach
    // blokow (__cmp_BlockTitle*). Sekcja = { key, element (tytul), rows: [[name, element]...][],
    // consents } - sekcja zgod (same pola consent*) renderuje sie jako karta
    // z licznikiem i przyciskiem "zaznacz wszystkie wymagane"
    stepSections(){

      let sections = [],
          cur = { key: '__head', element: null, rows: [] },
          push = () => (cur.rows.length || cur.element) && sections.push(cur);

      for (let idx in this.stepForm) {

        if (!this.stepForm.hasOwnProperty(idx)) {
          continue;
        }

        let item = this.stepForm[idx];

        if (String(idx).match(/^__cmp_BlockTitle/)) {

          push();
          cur = { key: idx, element: item, rows: [] };
          continue;
        }

        if (String(idx).match(/^__goto|^__endpoint|^__wait|^__amount|^__cmp/)) {
          continue;
        }

        if (String(idx).match(/^__row/)) {

          cur.rows.push(Object.keys(item).map(n => [n, item[n]]));
          continue;
        }

        cur.rows.push([[idx, item]]);
      }

      push();

      // zgody (consent* i CheckToggler "zaznacz wszystkie") wydzielamy z sekcji
      // z polami do osobnej karty - w NAU form_config nie ma dla nich tytulu bloku
      // CheckToggler liczy sie jako element zgod tylko, gdy steruje zgodami (bind: consent...),
      // a nie polami formularza (show: adres korespondencyjny itp.)
      let isConsentToggler = e => (e[1] || {}).component == 'CheckToggler' && /consent/.test(String((e[1] || {}).bind || '')),
          isConsentEntry = e => /^consent/.test(e[0]) || isConsentToggler(e),
          out = [];

      sections.forEach(s => {

        let plain = s.rows.map(r => r.filter(e => !isConsentEntry(e))).filter(r => r.length),
            cons  = s.rows.map(r => r.filter(e => isConsentEntry(e))).filter(r => r.length);

        if (plain.length && cons.length) {

          out.push({ key: s.key, element: s.element, rows: plain });
          out.push({ key: s.key + '__consents', element: { title: 'Oświadczenia i zgody' }, rows: cons });
        }
        else {
          out.push(s);
        }
      });

      sections = out;

      sections.forEach(s => {

        let entries = [].concat(...s.rows),
            isToggler = e => isConsentToggler(e);

        // sekcja zgod: same pola consent* (plus ew. CheckToggler "zaznacz
        // wszystkie" - w karcie zastepuje go przycisk w naglowku)
        s.consents = entries.length > 0 && entries.every(e => /^consent/.test(e[0]) || isToggler(e));

        s.consents && (s.rows = s.rows
          .map(row => row.filter(e => !isToggler(e)))
          .filter(row => row.length));
      });

      return sections;
    },


    // zgody wymagane biezacego kroku - pojedyncze CheckInput z walidacja accepted
    requiredConsentNames(){

      return Object.keys(this.stepForm || {}).filter(n =>
        /^consent[0-9]+$/.test(n)
        && this.stepForm[n].component == 'CheckInput'
        && this.stepForm[n].vuelidation
        && this.stepForm[n].vuelidation.accepted);
    },


    consentsChecked(){

      return this.requiredConsentNames.filter(n => this.form[n] === true).length;
    },


    consentsPct(){

      return this.requiredConsentNames.length
        ? Math.round(this.consentsChecked / this.requiredConsentNames.length * 100)
        : 0;
    },


    ctaHint(){

      let left = this.requiredConsentNames.length - this.consentsChecked,
          zg = left == 1 ? 'wymaganą zgodę' : left < 5 ? 'wymagane zgody' : 'wymaganych zgód';

      if (left > 0) {
        return 'Uzupełnij dane i zaznacz ' + left + ' ' + zg;
      }

      if (String(this.specialStep).match(/^verifycode/)) {
        return 'Wpisz kod z SMS-a, aby przejść dalej';
      }

      return this.activeStep == this.steps
        ? 'Wniosek trafi do nas od razu'
        : 'Sprawdzimy dane i przejdziemy do kolejnej części';
    },


    installmentAmount(){


      return (this.loanAmount / this.loanTenor).toFixed(2);
    },



    specialStep(){

      return this.schema[ this.activeStep-1 ].hasOwnProperty('__goto') ? this.schema[ this.activeStep-1 ].__goto : false;
    },


    stepForm() {


      this.activeStep == 1 && this.$router.currentRoute.path != '/'
        && this.$router.push({path: '/'});

      // set route
      this.activeStep > 1 && this.activeStep < 4
          && this.$router.push({path: ['quickform','verifycode','fullform','kontox'][this.activeStep-1]});



      if (this.schema[ this.activeStep-1 ].hasOwnProperty('__goto')) {

        return {};
      }


      return this.schema[ this.activeStep-1 ];
    },


    validationRules() {

      let rules = {},
          step =  this.schema[ this.activeStep-1 ],


          addValidation = (r, step, force=false) => {


            if (step.hasOwnProperty(r) && step[ r ].hasOwnProperty('vuelidation') && (!step[ r ].hasOwnProperty('hidden') || force)) {


              rules[ r ] = {};


              let def = step[r].vuelidation;


              for (let idx in def) {


                if (def.hasOwnProperty(idx)){


                  switch (idx) {

                    case 'required':

                      rules[r].required = required;
                      break;

                    case 'accepted':

                      rules[r].accepted = v => v === true;
                      break;

                    case 'email':

                      rules[r].email = email;
                      break;

                    case 'minLength':

                      rules[r].minLength = minLength(def[ idx ]);
                      break;

                    case 'maxLength':

                      rules[r].maxLength = maxLength(def[ idx ]);
                      break;

                    case 'sameAs':

                      rules[r].sameLike = sameAs(def[ idx ]);
                      break;

                    case 'alpha':

                      rules[r].alpha = alpha;
                      break;

                    case 'passwordPolicy':
                      rules[r].passwordPolicy = v => {
                      return this.passwordPolicy(v)
                      };
                      break;


                    case 'latin':
                      rules[r].latin = v => /[A-Za-z]/.test(v);
                      break;

                    case 'pesel': 
                      rules[r].pesel = validatePolish.pesel;
                      break;

                    case 'nip': 
                      rules[r].nip = validatePolish.nip;
                      break;

                    case 'idcard': 
                      rules[r].idcard = validatePolish.identityCard;
                      break;


  


                    default:
                  }
                }
              }
            }
          };




      // include dynamic fields
      //step = {...step, ...this.dynamicValidation};



      for (let r in step ) {

        if (String(r).match(/^__row/)) {

          for (let i in step[r]) {

            addValidation(i, step[r]);
          }

        }
        else {

          addValidation(r, step);
        }
      }


      // set dynamic validations
      Object.keys(this.dynamicValidation).map( k => {

        addValidation(k, this.dynamicValidation, true);
      } );


      if (this.specialStep == 'verifycode') {

        rules['verifycode'] = {
          minLength: minLength(4),
          maxLength: maxLength(4),
          required: required
        }
      }

      return rules;
    }
  },

  validations() {

    return {
      form: this.validationRules
    }
  },


  //
  //              METHODS
  //
  methods: {






    postKontoxData(kontoxData= null) {

       var page = this.$root.mainpage;


        if (!!kontoxData) {

          this.waiting = 'application';
          this.waitCount = 0;

          page.isLoading = 'Przetwarzamy Twój wniosek…,Weryfikujemy przesłane dane…,To może potrwać kilka minut…,Dziękujemy za cierpliwość…'.split(',');

          this.post( '/bank', kontoxData)
          .then(response => {

            page.isLoading = !!this.waiting;

            if (!!response.data) {
              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              this.nextCB( ok, stage );
            }
          })
          .catch(error => {

              page.isLoading = false;

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }
          });
        }
    },



    verifyCode() {

       var page = this.$root.mainpage;


        //this.$v.form['verifycode'].$touch();

        if (String(this.form.verifycode).length > 0) {

          this.waiting = '';
          this.waitCount = 0;

          page.isLoading = true;



          this.post( '/activate', {

            client_email: this.form.client_email,
            activation_code: this.form.verifycode

          })
          .then(response => {

            page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);
              this.nextCB( ok );
            }


          })
          .catch(error => {
          //  console.log(error);


              page.isLoading = false;
              this.verifycode_hint = 'Wystąpił błąd.';

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

                  if (error.response.data.Message) {

                    this.verifycode_hint = error.response.data.Message.toString();
                  }
                  else if (error.response.data.MESSAGE) {

                    this.verifycode_hint = error.response.data.MESSAGE;
                  }


              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }


              this.form['verifycode'] = '';
              this.$v.form['verifycode'].$touch();

            //console.log('Network error', error);

          });
        }
    },



    onSubmit( endpoint='application' ) {


      var page = this.$root.mainpage,
        result = false;


      // set polling endpoint after main request complete
      this.waiting = this.stepForm.hasOwnProperty('__wait') ? this.stepForm.__wait : '';
      this.waitCount = 0;
      this.formErrors = false;

      // enable page loading mask
      page.isLoading = 'Zapisujemy dane z formularza…,Weryfikujemy przesłane informacje…,To może potrwać do minuty…,Dziękujemy za cierpliwość…'.split(','); //true;


//console.log(this.form);


      let r, r2, basic = this.getConf('basicSubmitParams'),

      form = {},

      consents = {},

      custom = {},

      params;


//console.log(this.form);

      for (let e in this.form) {

        if (this.form.hasOwnProperty(e)) {
          if (typeof this.form[e] == 'object' && this.form[e] !== null) {
            if (this.form[e].hasOwnProperty('value')) {

              form[e] = this.form[e].value;
            }
          }
          else {


            r = String(e).match(/consent([0-9]+)/);
            r2 = String(e).match(/custom-([0-9]+)/);


            if ( r && r.length > 1) {


              consents[ r[1] ] = 1;
            }
            else if (r2 && r2.length > 1) {

              custom[ r2[1] ] = this.form[e];
            }
            else {

              form[e] = this.form[e];
            }
          }
        }
      }


      // convert to json string
      custom = JSON.stringify(custom);


      params = {...basic, ...form, client_consents: consents, custom_fields: custom};


      if (page.loggedIn) {

        params['client_id'] = page.loggedIn.client_id;
      }


      // clean spaces from nrb field
      //params.client_bank_account && (params.client_bank_account =  params.client_bank_account.split(' ').join(''));



      // clean cellphone
      params.client_cellphone && (params.client_cellphone = params.client_cellphone.split('-').join(''));

      // loan amount
      params.requested_amount = this.loanAmount;

      // loan installments
      params.requested_installments = this.loanTenor;



      this.post( '/' + endpoint, params )
            .then(response => {

              page.isLoading = !!this.waiting;

              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              response.data.hasOwnProperty('Message')
                  && (this.form.loan_id = response.data.Message);


              this.nextCB( ok, stage );

            })
            .catch(error => {

              page.isLoading = false;

              let err = error.response.data.Message;

              if (err) {

                this.pageTop();

                this.formErrors = true;

                this.invalidFields = [];


                for (let bind in err) {


                  if (err.hasOwnProperty(bind)) {

                    this.echo('invalid_field', bind, err[ bind ].join(', '));


                    // if some field in error is not present on the form
                    //!this.form.hasOwnProperty( bind ) && 
                    this.invalidFields.push( bind );
                  }
                }

                //this.verifycode_hint = error.response.data.Message.toString();

              }
              else {
                err = error.response.data;

                if (err.hasOwnProperty('PAYLOAD') && String(err.PAYLOAD).match(/do panelu/)){

                  // login to client account info
                  this.echo('next_step_fail');  
                }

              
                /*console.log("to tutaj");*/
               // 
              //console.log('Network error', error);

              }

     
            });



            return result;



 //     console.log('Submit clicked');
    },



    onWaiting( endpoint='application' ) {


      var page = this.$root.mainpage,
          step;

      // wyczysc komunikat z poprzedniej sesji odpytywania
      page.pendingMessage = '';

      var poll = () => {

          // 3 sek * 120 = 6 min
          if (this.waitCount > 120){

            page.isLoading =false;

            // timeout page
            this.routeToStage('pending');
            return;
          }

          this.waitCount++;



          this.get( '/' + endpoint )
              .then(response => {


                if (!!response.data) {

                  step = response.data.hasOwnProperty('step') ? response.data.step : '';

//console.log(step);

                  switch (step) {

                    case 'wait':
                      break;

                    case 'reject':
                      page.isLoading=false;
                      this.routeToStage('reject');
                      return;

                    case 'kontox':

                      page.isLoading =false;

                      this.doNextStep('kontox');
                      return;

                    case 'counteroffer':
                      page.isLoading =false;
                      this.routeToStage('proposal', response.data);
                      return;

                    case 'account':
                      page.isLoading =false;
                      this.routeToStage('account');
                      return;

                    case 'not defined':
                      //console.log('not definedd');

                      // brak rekordu w loans - utrwal status z bufora (m.in. sp_faults w reject_reason)
                      this.log('application status without loan row', response.data);

                      // user-friendly komunikat bledu przetwarzania -> strona /pending
                      page.pendingMessage = this.pendingErrorMessage( response.data );

                      page.isLoading =false;
                      this.nextCB( true, 'pending' );
                      return;

                    case 'authologic_start':
                      page.isLoading=false;
                      window.location = response.data.step_details;
                      return;

                    case 'easycheck':
                      page.isLoading=false;
                      window.location = response.data.step_details;
                      return;

                      

                    default:
                      page.isLoading =false;
                      this.nextCB( true );
                      return;
                  }

                }
                else {

                  console.log('status reutrned an empty response')
                }


                // dispatch another poll request
                page.isLoading
                    && setTimeout(poll, 3000);


              })
              .catch(error => {


                  var resp = error && error.response,
                      noEndpoint = resp && resp.data && /No endpoint/i.test( resp.data.Message || resp.data.MESSAGE || '' );

                  // twardy brak endpointu statusu po stronie API - nie odpytujemy
                  // w kolko przez 6 min, tylko od razu na /pending
                  if (noEndpoint) {

                    this.log('status endpoint - No endpoint, przerywam polling', resp.data);

                    page.isLoading = false;
                    this.routeToStage('pending');
                    return;
                  }


                  // wait fot timeout insted
                  //page.isLoading = false;
                  setTimeout(poll, 3000);

                  // Error
                  if (error.response) {


                  } else if (error.request) {

                  } else {
                      // Something happened in setting up the request and triggered an Error
                      //console.log('Error', error.message);
                  }
              });


        };


        // initial polling
        setTimeout(poll, 3000);
    },



    // Buduje user-friendly komunikat bledu przetwarzania z reject_reason (sp_faults).
    // reject_reason bywa JSON-em, np.:
    // {"error":1,"type":"sp","message":"KLIENT O TAKIM NUMERZE ... JEST JUZ W SYSTEMIE","db_msg":false,"msk":false}
    pendingErrorMessage( data ){

      if (!data || !data.reject_reason) {
        return '';
      }

      let raw = data.reject_reason,
          obj = null,
          msg = '';

      // reject_reason moze przyjsc jako string JSON lub juz jako obiekt
      if (typeof raw === 'object' && raw !== null) {

        obj = raw;
      }
      else {

        try {
          obj = JSON.parse(raw);
        }
        catch (e) {
          obj = null;
        }
      }

      if (obj && obj.message) {

        msg = String(obj.message).trim();
      }
      else if (typeof raw === 'string' && data.status_name === 'Błąd przetwarzania wniosku') {

        // zwykly tekst bledu z bufora
        msg = raw.trim();
      }

      if (!msg) {
        return '';
      }

      // komunikaty z bazy bywaja zapisane CAPS-LOCKiem - sprowadz do formy zdaniowej
      if (msg === msg.toUpperCase()) {

        msg = msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase();
      }

      return msg;
    },



    routeToStage(stage='thankyou', data=null) {


      switch (stage) {

        case 'done':
          this.$router.push({path: 'thankyou'});
          break;


        case 'pending':
          this.$router.push({path: 'pending'});
          break;

        case 'step_details':
          this.$router.push({path:'step_details'});
          break;

        case 'account':
          this.$router.push({path: 'account'});
          break;


        case 'proposal':

          this.finishDate = data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
          //this.setValues(data.net_amount);

          this.setValues(parseInt(data.net_amount), this.getConf('default_tenor'), this.getConf('tenor_sign') );


          this.$router.push({path: 'proposal'})
                .then(  () => {

                  //bus.$emit('proposal_amount', data);

                })
                .catch(() => {});

          break;


        case 'reject':
          this.$router.push({path: 'rej'});
          break




        default:

          this.$router.push({path: 'thankyou'});
      }
    },





    // --- redesign (CardFinance2) ---
    // "Zaznacz wszystkie wymagane" - CheckInput nasluchuje 'checktoggle'
    // (lista nazw po przecinku) i klika w swoj checkbox, wiec walidacja
    // i zdarzenia dzialaja jak przy recznym zaznaczeniu
    checkAllRequired(){

      let left = this.requiredConsentNames.filter(n => this.form[n] !== true);

      left.length && this.echo('checktoggle', left.join(','), true);

      this.log('CONSENTS_CHECK_ALL', 'step=' + this.activeStep, 'count=' + left.length);
    },


    // sekcja z ukrytym tytulem bloku (np. adres korespondencyjny przed
    // zaznaczeniem CheckTogglera) - nie zostawiamy pustego odstepu
    isBlockHidden(sec){

      if (!sec.element) {
        return false;
      }

      return this.hiddenBlocks[sec.key] !== undefined
        ? this.hiddenBlocks[sec.key]
        : !!sec.element.hidden;
    },


    filldebug($ev) {

        this.echo('filldebug');
    },


    // next callback
    nextCB(result=false, stage='done') {

      var page = this.$root.mainpage;

      if (!page.isLoading) {
        this.waiting = false;
        this.waitCount = 0;
      }

      // bad request
      if (!result){
        //error message here
        return;
      }



      if (!this.waiting) {

        if (this.activeStep < this.steps) {

          this.doNextStep();
        }
        else {

          this.routeToStage( stage );
        }
      }
      else {

        this.onWaiting( this.waiting );
      }

    },


    // Sprawdza czy wniosek/użytkownik o podanych danych już istnieje.
    // Jeśli tak — przekierowuje do logowania (otwiera modal) i przerywa flow.
    // Jeśli nie — Promise się rozwiązuje i wniosek jest kontynuowany.
    existCheck(phone=null, email=null, pesel=null){

      return new Promise((resolve, reject) => {

        var page = this.$root.mainpage;

        // wylaczone w configu (endpoint /existsapi niezaimplementowany) - pomijamy
        if (this.getConf('existsapi') === 'off') {

          resolve('exist check disabled');
          return;
        }

        // pomijamy gdy kontynuujemy istniejący wniosek lub wejście z linku/otp
        if (!!this.form['loan_id'] || page.isRegisterLink){

          resolve('exist check skip');
          return;
        }

        // bez kompletu danych nie ma czego sprawdzać — kontynuuj
        if (!phone || !email) {

          resolve(null);
          return;
        }

        // personal loans so skip nip param by setting to int 0, other values are validated as error
        let nip = pesel || 0,
            query = [email, phone, nip].join('/');


        this.log('- EXIST CHECK - ', 'GET /existsapi/', query);

        page.isLoading = true;


        this.get( '/existsapi/' + query )
        .then(response => {

          page.isLoading = false;

          // Brak leada: backend zwraca 204 / pustą odpowiedź (NIE error).
          // Axios traktuje 204 jako sukces (.then) z response.data === '' —
          // dlatego łapiemy też pusty string / pusty obiekt / pustą tablicę.
          var d = response.data;
          var isEmpty = d === null || d === undefined || d === ''
            || (typeof d === 'object' && Object.keys(d).length === 0);

          if (isEmpty) {

            this.log('- EXIST CHECK - brak leada (puste/204) → kontynuuj wniosek');
            resolve(null);
            return;
          }

          let dat = response.data,
              ok = !(dat.IS_ERROR | 0);

          if (ok) {

            // użytkownik/wniosek już istnieje → przekierowanie do logowania
            this.log('- EXIST CHECK - użytkownik istnieje → przekierowanie do logowania');
            this.echo('login_dialog');
            reject(dat);
            return;
          }

          // błąd po stronie danych — kontynuuj wniosek
          resolve(null);
        })
        .catch(error => {

          page.isLoading = false;

          if (error.response) {

            let dat = error.response.data;

            // "Data not found" = nowy użytkownik → kontynuuj wniosek
            if (!!dat && dat.hasOwnProperty('Message') && /Data not found/.test(dat.Message) ) {

              resolve(dat);
              return;
            }
          }

          // przy innym błędzie nie blokujemy użytkownika — kontynuuj
          this.log('- EXIST CHECK - błąd sprawdzenia, kontynuuję wniosek', error);
          resolve(null);
        });
      });

    },


    next($ev) {

//console.log(this.stepForm);


      // najpierw sprawdź czy użytkownik już istnieje — jeśli tak, pokaż logowanie i przerwij
      this.existCheck(this.form['client_cellphone'], this.form['client_email'], this.form['client_PESEL'])

      .then(() => {

        // CURRENT STEP
        // chcek if current step is posting data

        if (this.stepForm.hasOwnProperty('__endpoint')) {

          this.onSubmit(this.stepForm.__endpoint.trim());

          // above async so return so far, continue with callback
          return;

        }

        else if (this.specialStep == 'verifycode') {

          this.verifyCode();

          // above async so return so far, continue with callback
          return;
        }
        // END CURRENT STEP



        this.doNextStep();

      })
      .catch(() => {

        // użytkownik istnieje — modal logowania już otwarty, zatrzymujemy flow
      });


    },


    doNextStep(goto=''){


      if (!!goto) {

        let stage = ['quickform','verifycode','fullform','kontox'].indexOf( goto );


        if (stage > -1) {

          this.activeStep = stage;
        }
        else {
          let as = 0;
          this.schema.map( s => {

            if (s.hasOwnProperty('__goto')) {

              if (s.__goto == goto) {

                this.activeStep = as;
              }
            }

            as++;
          });
        }
      }



      // GO TO NEXT STEP
      if (this.schema[this.activeStep]) {

        let step = this.schema[this.activeStep];



        if (step.hasOwnProperty('__goto')) {

            switch (step.__goto) {

              case 'kontox':


                //this.$router.push({path: 'kontox'});
                // index.js
                embedKontomatik({
                  client: this.getConf('kontomatikClient' + (this.debug == 'on' || this.tests == 'on' ? 'Test' : '')),  // replace it with your assigned client id
                  divId: 'kontox',       // must match the div element id
                  locale: 'pl',       // ui language
                  onSuccess: (target, sessionId, sessionIdSignature, options) => {
                    // End-user successfully signed in to the bank
                    // Pass target, sessionId and sessionIdSignature to your backend
                    //alert('It works!');

                    this.postKontoxData({
                      "session_id": sessionId,
                      "session_id_signature": sessionIdSignature,
                      "internet_loan_request_id": this.form.loan_id
                    });
                  }
                });

                break;

            }


            // scroll to top with .5s delay
            this.pageTop();
        }

        //else {

  //console.log($ev)

          this.activeStep++;
        //}
      }
    },





    prev() {

      this.activeStep--;


    },


    testroute() {



/*

let dt = {"status_name":"Kontroferta","color":"blue","icon":"thumbs-up","step":"counteroffer","net_amount":"1000.0000","gross_amount":".00","interest_amount":"6.0000","loan_date":"2021-09-26 00:00:00.000","last_installment_date":"2021-10-26 00:00:00.000","lead_id":"1006","loan_id":"517","client_id":"360","status_id":".40","pay_out_type":"1","reject_reason":null,"contract_nbr":" UM-353\/09\/2021","agent_id":"2","installments_nbr":"1","installment_amount":"1280.00","initial_payment":"0","insurance_amount":".0000","service_fee":".0000","loan_status_date":"2021-09-26 16:03:48.077"};




this.routeToStage('proposal', dt);


*/

      //console.log(this.$root);


     // let page = this.$root.mainpage;



//window.scrollTo(0,0)


//document.documentElement.style.overflow = 'hidden';


/*var del = document.documentElement,

top = del.scrollTop;



console.log(top);


window.addEventListener('scroll',  function(){

console.log(top)
 // del.scrollTop = top;


  window.scrollTo(0, top);


}, false);
*/






//document.body.style.overflow='hidden';

//console.log(document)




/*
      this.$router.push({path: '/proposal'})
      .then(  () => {


        bus.$emit('proposal_amount', 950);

      })
      .catch(() => {});


*/

      this.page.isLoading = true;

      /*setTimeout(() => {



        nau.isLoading = false


        this.$router.push({path: 'kontox'});


      }, 3000)*/



    },



    fillUp(item){


//console.log('fill item ' + item);



      return this.fmap.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ this.fmap[item] ]) || this.page.loggedIn.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ item ]);
    },



    fillForm(){

      if (!this.page.loggedIn) {
        return;
      }

      this.delayedTask = null;


      let get = n => this.page.loggedIn[ n ],

          // nie nadpisuj pol pustymi/placeholderowymi danymi z poprzedniego wniosku
          // (m.in. blokuje propagacje niepoprawnej daty 1970-01-01 / 1900-01-01)
          skipEmpty = k => /client_identity|client_PESEL|client_address2/.test(k)
            && ( !get(this.fmap[k]) || !String(get(this.fmap[k])).trim() || (/_date/.test(k) && /1970-01.01|1900-01-01/.test(get(this.fmap[k]))) );


      // special fill ups - polish citizen check
      this.echo('fill_up', 'country', 1);


      // propaguj wszystkie dostepne pola procesu (config: fields_mapping)
      Object.keys(this.fmap).map( k => {

        if (skipEmpty(k)) return;

        let val = get(this.fmap[k]);

        // nie wpisuj null/undefined do form (psuje onSubmit: typeof null === 'object')
        if (val === null || val === undefined) {

          return;
        }

        // kwoty jako liczby calkowite
        if (/client_costs|client_employment_income/.test(k) && val !== '') {

          val = Math.round(parseFloat(val));
        }

        // daty: przytnij do 'YYYY-MM-DD' (loggedIn potrafi zwrocic datetime)
        if (/_date$|_start$/.test(k) && typeof val === 'string') {

          let m = val.match(/^\d{4}-\d{2}-\d{2}/);
          val = m ? m[0] : '';
        }

        // utrzymaj globalny objekt form (rowniez dla pol z dalszych krokow)
        this.$set(this.form, k, val);

        // wypelnij aktualnie zamontowane inputy (wartosc + maska + walidacja)
        this.echo('fill_up', k, val);
      });



      this.fillDone = true;
    }



  },



  created() {

    this.page = this.$root.mainpage;

    // mapa pol formularza -> klucze danych zalogowanego klienta (poprzedni wniosek).
    // Trzymana w config.json (fields_mapping), aby kolejny wniosek mial
    // propagowane wszystkie dostepne w procesie pola.
    this.fmap = this.getConf('fields_mapping') || {};


   // console.log(__CFG)


   let uri = window.location.href.split('?');

   //console.log(uri);


   if (uri.length > 1 && /amount=[0-9]+/.test(uri[1]) ) {


      let reg = uri[1].match(/amount=([0-9]+)/);

      this.loanAmount = reg[1];
   }



    // initial amount set
    this.setValues(this.loanAmount, this.getConf('default_tenor'), this.getConf('tenor_sign'));




//console.log('fees as folows  ' + this.service + ' ' + this.interest);


    this.listen('calc_edit_done', () => {


      if (this.editMode !== 'persist') {

        this.editMode = false;
      }
    });


    // widocznosc tytulow blokow (sekcji) - to samo zdarzenie, ktorym
    // CheckToggler pokazuje/ukrywa pola i BlockTitle
    this.listen('visibility', (bind, checked) => {

      String(bind).split(',').forEach(n =>
        /^__cmp_/.test(n) && this.$set(this.hiddenBlocks, n, !checked));
    });


    // dynamic validations
    this.listen('dynamic_validation', (bind, enabled) => {


      // remove if not set
      if (!enabled && this.dynamicValidation.hasOwnProperty(bind)){

        delete this.dynamicValidation[ bind ];
      }

      // iterate current form
      Object.keys(this.stepForm).map( k => {
        if (k.match(/^__row/)) {
          Object.keys(this.stepForm[k]).map( sk => {

            sk == bind && !!enabled
              && (this.dynamicValidation[ sk ] = this.stepForm[k][sk]);
          });
        }
        else {

          k == bind && enabled
            && (this.dynamicValidation[ k ] = this.stepForm[k]);
        }
      });


      // force vue to re-apply validations
      this.dynamicValidation = {...this.dynamicValidation};

    });




    // client session id for quicksave and full form
    if (!this.page.uuid) {

      //this.page.uuid = window.__sid || uuidv4();   

      // new session every time, cause different users can use the same device
      this.page.uuid = uuidv4();      
    }



    // client session id for quicksave and full form
    this.form['external_id'] = this.page.uuid



    // load schema locally first (bundled form_config), fallback to remote /config
    if (__form_config) {

      this.schema = __form_config;
      this.steps = this.schema.length;
    }


    this.get( '/config' + (!uri[1] ? '' : '?' + uri[1]), null, {
          baseURL: this.getConf('secondaryEndpoint')
        } )
        .then(response => {

          // in case not loaded locally
          if (!this.schema) {

            this.schema = response.data;
            this.steps = this.schema.length;
          }


          // debug sterowany z config.json (getConf('debug')) - jak w fingo
          //this.debug = this.schema.length > 0 && this.schema[0].hasOwnProperty('__endpoint') && this.schema[0].__endpoint[0] == ' ';


          // default amount
          if (this.schema.length > 0 && this.schema[0].hasOwnProperty('__amount') && !String(uri[1]).match(/amount/) ) {

            this.setValues(this.schema[0].__amount, this.getConf('default_tenor'), this.getConf('tenor_sign'));

          }


          this.isFilled = this.page.loggedIn && this.steps > 0;

        })
        .catch(error => {
          console.log('Network error', error);
        });


  },


  mounted() {



  },



  updated() {



    // logged in so redirect to fullform
    if (this.activeStep == 1 && this.steps > 0 && this.page.loggedIn) {

      this.doNextStep('fullform');
    }


    // go to fullform step and fill data
    if (this.page.loggedIn && typeof this.page.loggedIn == 'object' && this.steps > 0 && !this.fillDone ) {


      if (this.delayedTask) {

        this.delayedTask = clearTimeout(this.delayedTask);
      }


      this.delayedTask = setTimeout(this.fillForm, 800);

    }



  }
}
</script>


<style>

/* uklad i pola: src/assets/cf-theme.css (wspolna warstwa redesignu);
   tu tylko drobiazgi formularza NAU */

/* kalkulator NAU (karta z gradientem) wypelnia ramke mobilna w calosci */
.cf-form__calc-mobile {
  padding: 0;
  border: 0;
}

/* kolumna kalkulatora: szersza i z mniejszymi marginesami, zeby karta
   kalkulatora (jak dawny CalcSlider) zajmowala cala szerokosc kolumny */
.cf-form .cf-promise {
  grid-template-columns: 1fr 430px;
}

.cf-form .cf-promise__aside {
  padding: 32px 16px 40px;
}

@media (max-width: 900px) {
  .cf-form .cf-promise {
    grid-template-columns: 1fr;
  }
}

.cf-kontox {
  min-height: 320px;
  display: flex;
  justify-content: center;
}

.cf-form .cf-promise__aside .cf-btn--block {
  min-height: 52px;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/DynamicForm.vue